import { render, staticRenderFns } from "./vCheckboxQuestion.vue?vue&type=template&id=9d604a1a&scoped=true"
import script from "./vCheckboxQuestion.vue?vue&type=script&lang=js"
export * from "./vCheckboxQuestion.vue?vue&type=script&lang=js"
import style0 from "./vCheckboxQuestion.vue?vue&type=style&index=0&id=9d604a1a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d604a1a",
  null
  
)

export default component.exports